export default "__VITE_ASSET__By6MiEjh__"